<template>
<div>

        
        <h4 class="ml-4">
          <i class="fas fa-calculator mr-2" aria-hidden="true"></i>
          MODIFICA PREZZO DI ACQUISTO,SCONTO,IVA E PREZZO DI VENDITA PRODOTTO
        </h4>
       <product-info class="mt-1 ml-4" v-bind:productId="productId"></product-info>           
      <form v-on:submit.prevent="submit()">
      <div class="">

      <div class="form-row align-items-center">  

        <div class="col-auto mr-1">

          <input-prezzo

              v-model     = "prices.price1"
              :autofocus  = "true"
             
              label       = "PREZZO DI ACQUISTO"
              :min        = "0.01"
              :max        = "10000"
              @input      = "setCostPrice()"
              placeholder = "Inserisci prezzo di acquisto" 
              :required   = "true"
              
            />
          
          

        </div>
   
      <div v-if="!inputSconto.length" class="col-auto">
        <button type="button" @click="add()" class="btn btn-link">INSERISCI SCONTO</button>
      </div>

    <!-- INPUT SCONTO -->
    <div class="col-auto"
             
        v-for="(item,index) in inputSconto"
        :key="item.id"
      >
        <input-sconto
          ref="scontoInputs"
          class   = "mr-1"
          v-model = "item.discount"
          :label  = "item.label"
          :min    = "0"
          :max    = "100"
          @add    = "add()"
          :show-add = "index === inputSconto.length - 1 && inputSconto.length < 3"
        />
      
    </div>

    <div class="col-auto">
      
        <label for="inputVat"><strong>aliquota Iva</strong></label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text perc">%</div>
                </div>  
          <input required type="number" class="form-control" placeholder="" v-model="prices.vat">
      
          </div> 
    </div>   
    <div class="col-auto">
      
        
        <label  for="inlineFormInput2">Calcola Ricarico </label>
               <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text perc">%</div>
                </div>
              <input  type="number" class="form-control " id="mult" placeholder="" v-model="multiplier">
              <button type="button" :disabled="!prices.price1 || !multiplier" @click="setCalc()"  title="Calcola ricarico"  class="btn calc pointer" id="basic-addon1"><i class="fas fa-calculator" aria-hidden="true"></i></button>
                <div class="input-group-append">
                <div class="input-group-text">

                  <span style="font-size: 15px;" class="badge badge-light">Ricarico {{markUp}}</span>

                </div>
                  
            </div>
        
      </div> 
      </div>
      <div class="col-auto">
        <label for="inputPrice2"><strong>PREZZO DI VENDITA</strong></label>
        <div class="input-group mb-2">
                <div class="input-group-prepend">
                <div class="input-group-text euro">€</div>
                </div>  
                <input step="0.01" @input="setMarkUp()" required v-model="prices.price2"  class="form-control"   type="number" v-bind:placeholder="'Prezzo di vendita'">   
                
        </div>
        
        
      </div>
      
     
    

</div>
  <priceList @update="setPriceList" v-bind:product="orderPrices" v-bind:costPrice="costPrice" v-bind:retailPrice="retailPrice" ></priceList>       
</div>


 <!-- CHECKBOX sopra -->
  <div v-if="false" class="form-group form-check mb-3 text-right box-variazione">
      <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="flagVariazioneListino">
      <label class="form-check-label pointer" for="exampleCheck1">
       RICORDAMI VARIAZIONE LISTINO DI VENDITA ALLA CONSEGNA
      </label>
  </div>

<div class="alert alert-warning border border-info" role="alert">
  <div v-if="true" class="form-group form-check mb-3 text-right box-variazione_">
      <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="flagVariazioneListino">
      <label class="form-check-label pointer" for="exampleCheck1">
       RICORDAMI VARIAZIONE LISTINO DI VENDITA ALLA CONSEGNA
      </label>
  </div>

</div>
      
      <div class="modal-footer">
       <button type="button" @click="$emit('back')"  class="btn btn-secondary  ml-2 ">
       <i style="color:yellow" class="fas fa-reply  mr-2" aria-hidden="true"></i>
          RITORNA A MODIFICA VARIANTI 
       </button>
 


        <button v-if="false" @click="priceTable = true" type="button" class="btn btn-secondary mr-3" >MOSTRA TABELLA PREZZO PER MISURA</button>
        <button  type="submit" class="btn btn-primary" >
          <i class="far fa-save mr-3" aria-hidden="true"></i>     
          REGISTRA MODIFICA ORDINE</button>
      </div>

</form>



   <div v-if="false">
      <h5 class="mb-4">Dati JSON :</h5>
      <pre> {{ inputSconto }}  </pre> 
      
  </div>

</div>
</template>

<script>
import productInfo           from '@/components/product/ProductInfo.vue'
import priceList             from '@/components/order/PriceList.vue'

import { mapGetters }        from 'vuex'
import inputPrezzo           from '@/components/InputCustom/InputPrezzo.vue'
import inputSconto           from '@/components/InputCustom/InputSconto.vue'


export default {
  
  components: {priceList,productInfo,inputSconto,inputPrezzo},  
  props: ['orderPrices','gridVariants','variazioneListino','discounts','productId'],
 
  data () {
  
    return {
     
     inputSconto : [],

        
     prices      : {}, 
     multiplier  : '',
     markUp      : 0.00,
    
     priceTable  : false,
     
     costPrice   : 0,
     retailPrice : 0,

     barcodes    : [],
     priceList   : [],
     flagVariazioneListino : false
     
   
  
    }
  },
   directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          el.focus()
         /* el.select()*/
          }
       
      }
    },
  computed: 
    {     
     ...mapGetters(['company']) 
      
    },
          
  mounted()
    {
   
    },

  created()
  {
   
   
   this.flagVariazioneListino = this.variazioneListino 

   this.multiplier    = JSON.parse(localStorage.getItem("mult"))   
   this.prices.vat    = this.company.vat

   this.discounts.forEach(item=>
    {
      const l = this.inputSconto.length
      const obj = {'label' : l + 1 + '° sconto',discount : item.discount, id: l + 1 }
      this.inputSconto.push(obj)

    }
   ) 

   this.orderPrices.prices.forEach(item=>
   {
      if(item.costPrice > 0)
      {
        
        this.prices.price1 = item.costPrice
        this.prices.price2 = item.retailPrice


      }
   })

   
  },

  methods: 
  {

 add()
   {
    if(this.inputSconto.length < 3)
    {
      const l = this.inputSconto.length
      const obj = {'label' : l + 1 + '° sconto',discount : 0, id: l + 1 }
      this.inputSconto.push(obj)
      
       this.$nextTick(() => {
        const inputs = this.$refs.scontoInputs
        if (!inputs || !inputs.length) return

          const lastInput = inputs[inputs.length - 1]
          if (lastInput && lastInput.$el) {
            const inputEl = lastInput.$el.querySelector('input')
            if (inputEl) {
              inputEl.focus()   // mette il focus sull'input
              inputEl.select()  // seleziona tutto il valore
            }
          }
        })


      

    }

    

  },
  getTableBase(barcodesData, pricesData) {
  
  const costPrices   = pricesData[0].prezzi;
  const retailPrices = pricesData[1].prezzi;
  
  const items = [];

  barcodesData.forEach(item => {
    
    const colorId        = item.colorId;
    const supplierColor  = item.supplierColor;
    const quantities     = item.quantities;
    const barcodes       = item.barcodes;
    

    Object.keys(barcodes).forEach(sizeId => {
      const key                = String(sizeId)
      const order_qty          = Number(quantities[0][key])
      const delivered_qty       = Number(quantities[1][key]) 

      if(Number(order_qty) > 0 )
      {
        items.push({
          barcode          : barcodes[key],
          ean_13           : '',
          colorId          : colorId,
          supplierColor    : supplierColor,
          
          order_qty        : order_qty,
          delivered_qty    : delivered_qty,
          sizeId           : sizeId,
          
          costPrice        : costPrices[key],
          retailPrice      : retailPrices[key],
         
          /*
          discount         : this.inputSconto[0].discount, 
          discount2        : this.inputSconto[1].discount,
          discount3        : this.inputSconto[2].discount
          */
         

        })
      }
    })
  })

  

  const discounts = this.inputSconto
  .filter(item => item.discount > 0)
  .map((item, index) => ({
    discount: item.discount,
    id: index + 1   // indice che parte da 1
  }));

  const flagVariazioneListino = this.flagVariazioneListino
  return {items,discounts,flagVariazioneListino}
},

    setPriceList(data)
    {
      
      this.priceList = data
    },

    setCostPrice()
    {
      this.costPrice = this.prices.price1
      
    },
    submit()
    {
        const flagVariazioneListino = this.flagVariazioneListino
        const data =  {...this.getTableBase(this.gridVariants,this.priceList),flagVariazioneListino}      

        this.$emit('submit',data)

    },
    getDiscountedPrice()
    {
     
        let total = Number(this.prices.price1) || 0;

        for (const item of this.inputSconto) {
          
          // converte in number e verifica se è un valore valido > 0
          const d = Number(item.discount);
          if (!isNaN(d) && d > 0) {
            total -= (total * d) / 100;
          }
        }
        return total;


    },
    setCalc()
    {
      
      const total = this.getDiscountedPrice();
      
      const retailPrice = total + (total * this.multiplier) / 100
      
      this.prices.price2 = retailPrice.toFixed(2);
      localStorage.setItem('mult', JSON.stringify(this.multiplier));
      this.setMarkUp(total)
      
 },
 setMarkUp(price)
 {
  
  let price1 = !price ? this.getDiscountedPrice() : price
  
  this.markUp = 0
  if(Number(price1) > 0 && Number(this.prices.price2) > 0)
  {

    let n = Number(this.prices.price2) / Number(price1)
    this.markUp = n.toFixed(2)
  }

  this.retailPrice = this.prices.price2


 }
        
}
  
}
</script>

<style scoped>



.pointer{
  cursor: pointer;
}


h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
  
}
.euro{
  color             : white ;
  background-color  :  darkgreen;;
}

.calc{
  color: yellow;
  background-color:  #0787ff;;
}

.perc{
  color             : black;
  background-color:  rgb(236, 242, 233);;
}
.form-check-label{
  font-weight: bold;
  color: rgb(9, 14, 143);
}

.box-variazione {
  border: 1px solid #ffc107;
  background-color: #fff8e1;
  border-radius: 8px;
  padding: 14px 18px;
}
</style>